import config from 'config';

import { CompletedSignupV2Data } from 'domains/signupv2/Parent/signupMachineV2';

/** Returns the external insurance form URL */
const getInsuranceFormURL = (context: CompletedSignupV2Data) => {
  const queryParams = new URLSearchParams({
    cueid: context.leadID,
    cname: context.lastName,
    me: context.target === 'adult' ? 'yes' : 'no',
    phone: context.phoneNumber,
    email: context.email,
  }).toString();

  return `${config.get('salesforceInsuranceURL')}?${queryParams.toString()}`;
};

export const getRedirectAfterSignupV2Complete = (context: CompletedSignupV2Data): string => {
  if (context.insuranceInfo.useInsurance) {
    return getInsuranceFormURL(context);
  }
  return config.get('marketingThankYouURL') as string;
};
